import axios from "axios";
import { getCurrentJwt } from "./ConfigContext";
import { logoutWithRedirect } from "./JwtUtil";
import { toast } from "react-toastify";
// "X-Tenant-Id": "royal", // Ensure this header is always included

function safeParse(jsonStr) {
  try {
    return typeof jsonStr === "string" ? JSON.parse(jsonStr) : jsonStr;
  } catch {
    return {};
  }
}

let more_headers = {};
if (typeof ZoomHelper !== "undefined") {
  more_headers["x-detected-platform"] = "android";

  try {
    // eslint-disable-next-line no-undef
    const rawInfo = ZoomHelper.getDeviceInfo();
    const info = safeParse(rawInfo);
    const device = info?.device || {};

    Object.assign(more_headers, {
      "x-device-uuid": device.uuid || "",
      "x-device-model": encodeURIComponent(
        `${device.model || "unknown"}-${device.manufacturer || "unknown"}-${
          device.android_version || "unknown"
        }`
      ),
    });
  } catch (err) {
    console.error("Device info error:", err);
  }
} else if (window?.nativeBridge?.send || window?.chrome?.webview?.postMessage) {
  more_headers["x-detected-platform"] = "windows";
  // eslint-disable-next-line no-undef
} else if (typeof webkit !== "undefined" && webkit?.messageHandlers?.callback) {
  more_headers["x-detected-platform"] = "ios";
} else {
  more_headers["x-detected-platform"] = "web";
}

// ✅ Create a shared Axios instance
const api = axios.create({
  withCredentials: true,
});

// ✅ Add JWT token automatically to all requests
api.interceptors.request.use((config) => {
  // const token = localStorage.getItem("jwt");
  // if (token) {
  //   config.headers.Authorization = `Bearer ${token}`;
  // }
  // Merge device headers
  config.headers = {
    ...more_headers,
    ...config.headers,
  };
  return config;
});

// ✅ Auto logout on invalid or expired JWT
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("Error: ", error);
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.headers["logout-reason"]
    ) {
      // Show toast
      toast.info("JWT invalid or expired — logging out user...", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      logoutUser();
    }
    return Promise.reject(error);
  }
);

// ✅ Centralized logout function
function logoutUser() {
  const jwtData = getCurrentJwt();
  logoutWithRedirect(null, jwtData?.tenant);
}

// ✅ Helper functions for API methods
export const apiPost = (url, postData, headers = {}) => {
  return api.post(url, postData, {
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  });
};

export const apiPut = (url, putData, headers = {}) => {
  return api.put(url, putData, { headers });
};

export const apiGet = (url, headers = {}) => {
  return api.get(url, { headers });
};

export const apiDelete = (url, headers = {}) => {
  return api.delete(url, { headers });
};
